import { useState, useEffect, useRef } from 'react';

const useInView = (options = {}) => {
    const ref = useRef(null);
    const [inView, setInView] = useState(false);

    useEffect(() => {
        const el = ref.current;
        if (!el) return;
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setInView(true);
                    observer.unobserve(el);
                }
            },
            { threshold: 0.1, ...options }
        );
        observer.observe(el);
        return () => observer.disconnect();
    }, []); // eslint-disable-line

    return [ref, inView];
};

export default useInView;
